import React from 'react';
import GenericModal from '../GenericModal';
import IcmsCreditosPeriodoDrillDownContent from './IcmsCreditosPeriodoDrillDownContent';
import { ProductDrillDownSkeleton } from '../Skeletons/ModalSkeletons';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: any | null;
  loading: boolean;
  error: string | null;
  selectedPeriodo: { periodo?: string; sped_fiscal_id?: number | string } | null;
  onRetry: () => void;
}

const IcmsCreditosPeriodoDrillDownModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  data,
  loading,
  error,
  selectedPeriodo,
  onRetry
}) => {
  const tituloPeriodo = data?.periodo
    || selectedPeriodo?.periodo
    || (selectedPeriodo?.sped_fiscal_id ? `SPED ${selectedPeriodo.sped_fiscal_id}` : '');
  const tituloModal = tituloPeriodo
    ? `Detalhamento de Créditos de ICMS – ${tituloPeriodo}`
    : 'Detalhamento de Créditos de ICMS';

  return (
    <GenericModal
      open={isOpen}
      onClose={onClose}
      title={tituloModal}
      loading={false}
      maxWidth="lg"
      fullWidth
    >
      {loading ? (
        <ProductDrillDownSkeleton />
      ) : error ? (
        <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>
      ) : (
        data && <IcmsCreditosPeriodoDrillDownContent data={data} />
      )}
    </GenericModal>
  );
};

export default IcmsCreditosPeriodoDrillDownModal; 